module.exports = __webpack_public_path__ + "static/img/K1.16b2f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/K1.png
// module id = aHpY
// module chunks = 0